<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑国际短信模板' : '新增国际短信模板'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="业务" prop="code" :error="errors.code">
                        <Cascade ref="cascade" v-model="form.code" @change="loadGroup"></Cascade>
                    </el-form-item>
                    <el-form-item label="名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="分組" prop="groupId">
                        <RemoteSelect v-model="form.groupId" :options="groups" value-name="id" label-name="name"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="内容" prop="content" :error="errors.name">
                        <el-input type="textarea" v-model="form.content" :rows="5" maxlength="1000" show-word-limit></el-input>
                        <el-checkbox v-model="unsubscribe" @change="changeUnsubscribe">退订</el-checkbox>
                      <div style="color: red;">
                        <b>根据工信部要求：短信内容中，回复退订“T”或“TD”等退订格式，统一改为使用“拒收请回复R”</b><br>
                        <b>示例：短信息正文内容，拒收请回复R</b><br>
                      </div>
                        <div class="help-text">
                          <p>短信模板属于动态短信，根据配置的模板内容和上传的数据，自动替换占位符，并生成最终的短信内容。</p>
                          变量占位符格式为：[[name]]<br>
                          举例说明：尊敬的<strong>[[姓名]]</strong>，您的会员将于<strong>[[日期]]</strong>到期。<br>
                          <p>注意：变量个数不要超过10个，变量名称不能重复。</p>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Cascade from '@/components/Cascade'
    import RemoteSelect from '@/components/RemoteSelect'

    export default {
        components: {
            Cascade,
            RemoteSelect
        },
        props: ["id", "groupId"],
        data() {
            let validateContent = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error('请填写模板内容'));
                } else {
                    // let start = value.indexOf("【");
                    // if (start > -1 && value.lastIndexOf("】") > start) {
                    //     callback(new Error("根据运营商政策，文案中不能使用“【”“】”这2个签名专用括号，可使用「」或是 [ ] 代替，感谢！"));
                    // } else {
                        callback();
                    // }
                }
            };
            return {
                form: {
                    id: this.id,
                    name: "",
                    content: "",
                    groupId: 0,
                    code: ""
                },
                rules: {
                    name: [
                        {required: true, message: "请填写模板名称"}
                    ],
                    content: [
                        {validator: validateContent}
                    ],
                    code: [
                        {required: true, min: 6, message: "请选择业务"}
                    ],
                    groupId: [
                        {required: true, message: "请选择分组"}
                    ]
                },
                errors: {},
                unsubscribe: false,
                groups: []
            }
        },
        beforeMount() {
            if (this.form.id > 0) {
                this.$axios.get("/isms_template/get/" + this.form.id).then(result => {
                    this.$utils.merge(this.form, result);
                })
            }

            this.loadGroup(this.$root.code);
        },
        methods: {
            loadGroup(code) {
                this.form.groupId = 0;
                if (code && code.length > 5) {
                    this.$axios.post("/group/list", {
                        rules: [
                            {field: "type", value: "isms"},
                            {field: "code", value: code},
                        ]
                    }).then(data => {
                        this.groups = [{id:0, name: "默认"}].concat(data);
                        this.form.groupId = this.groupId;
                    });
                } else {
                    this.groups = [{id:0, name: "默认"}];
                }
            },
            submit() {
                let url = this.form.id > 0 ? "/isms_template/edit" : "/isms_template/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$emit("close", true);
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
                this.$emit("close", false);
            },
            changeUnsubscribe() {
                if (this.unsubscribe) {
                    this.form.content += "拒收请回复R";
                } else {
                    if (this.form.content && this.form.content.endsWith("拒收请回复R")) {
                        this.form.content = this.form.content.substring(0, this.form.content.indexOf("拒收请回复R"));
                    }
                }
            }
        }
    }
</script>